import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { eventName: String, params: Object };

  connect() {
    if (this.formHasTurboDisabled) {
      this.element.addEventListener("submit", this.onSubmit);
    } else if (this.element.tagName === "FORM") {
      document.addEventListener("turbo:submit-end", this.onTurboSubmit);
    } else {
      this.element.addEventListener("click", this.onClick);
    }
  }

  disconnect() {
    if (this.formHasTurboDisabled) {
      this.element.removeEventListener("submit", this.onSubmit);
    } else if (this.element.tagName === "FORM") {
      document.removeEventListener("turbo:submit-end", this.onTurboSubmit);
    } else {
      this.element.removeEventListener("click", this.onClick);
    }
  }

  get formHasTurboDisabled() {
    return (
      this.element.tagName === "FORM" && this.element.dataset.turbo === "false"
    );
  }

  onClick = () => this.trackEvent();

  onSubmit = () => this.trackEvent();

  onTurboSubmit = (event) => {
    if (event.detail.success && event.target === this.element) {
      this.trackEvent();
    }
  };

  trackEvent() {
    // Retry in case gtag hasn't loaded yet (e.g. returning onsite from Stripe).
    this.retry(() => {
      if (!window.gtag) return false;
      window.gtag("event", this.eventNameValue, this.paramsValue);
      return true;
    });
  }

  retry(attempt, attempts = 0, max = 10, interval = 500) {
    if (attempt()) return;
    if (attempts < max)
      setTimeout(
        () => this.retry(attempt, attempts + 1, max, interval),
        interval,
      );
  }
}
